import React from 'react';
import './Citation.scss';

function Citation() {
  return (
    <section className="copies">
      <p className="citation">
        <sup>1</sup> Phone interview with Ellen Buchanan Weiss, activist and founder of the website
        and Instagram account Brown Skin Matters. August 17, 2021.
      </p>
      <p className="citation">
        <sup>2</sup> Adelekun, A., Onyekaba, G., Lipoff, J. (2020). Skin color in dermatology
        textbooks: An updated evaluation and analysis.{' '}
        <span className="italic">J Am Acad Dermatol, 84</span>(1), P194-196.
        https://doi.org/10.1016/j.jaad.2020.04.084
      </p>
      <p className="citation">
        <sup>3</sup> Basra, MKA., Shahrukh, M. (2009). Burden of skin diseases.{' '}
        <span className="italic">Expert Rev Pharmacoeconomics Outcomes Res, 9</span>, 271-283.
        https://doi.org/10.1586/erp.09.23.
      </p>
      <p className="citation">
        <sup>4</sup> Nutten, S. (2015). Atopic dermatitis: global epidemiology and risk factors.{' '}
        <span className="italic">Ann Nutr Metab, 66</span>
        (suppl 1), 8-16. https://doi.org/10.1159/000370220
      </p>
      <p className="citation">
        <sup>5</sup> Wang, J., Ramette, A., Jurca, M., Goutaki, M., Beardsmore, C.S., Kuehni, C.E.
        (2017). Association between breastfeeding and eczema during childhood and adolescence: A
        cohort study. <span className="italic">PLoS One</span>,12(9).
        https://www.doi.org/10.1371/journal.pone.0185066
      </p>
      <p className="citation">
        <sup>6</sup> Bylund, S., von Kobyletzki, L.B., Svalstedt, M., Svensson, Å. (2020).
        Prevalence and Incidence of Atopic Dermatitis: A Systematic Review.{' '}
        <span className="italic">Acta Derm Venereol</span>, 100(12).
        https://www.doi.org/10.2340/00015555-3510
      </p>
      <p className="citation">
        <sup>7</sup> Mathiesen, S.M., Thomsen, S.F. (2019). The prevalence of atopic dermatitis in
        adults: systematic review on population studies.{' '}
        <span className="italic">Dermatol Online J</span>, 25(8).
        https://doi.org/10.5070/D3258045124
      </p>
      <p className="citation">
        <sup>8</sup> Phone interview with Zakiya Rice, MD, a dermatologist at Dermatology associates
        of Georgia. President of the Atlanta Association for Dermatology and Dermatologic Surgery.
        August 17, 2021.
      </p>
      <p className="citation">
        <sup>9</sup> Silverberg, J.I. (2019). Comorbidities and the impact of atopic dermatitis.{' '}
        <span className="italic">Ann Allergy Asthma Immunol, 123</span>(2). 144-151.
        https://doi.org/10.1016/j.anai.2019.04.020
      </p>
      <p className="citation">
        <sup>10</sup> Williams, H.C. (2005). Atopic dermatitis.{' '}
        <span className="italic">N Engl J Med, 352</span>(22). 2314-2324.
      </p>
      <p className="citation">
        <sup>11</sup> Kaufman, B.P., Guttman-Yassky, E., Alexis, A.F. (2018). Atopic dermatitis in
        diverse racial and ethnic groups-Variations in epidemiology, genetics, clinical presentation
        and treatment. <span className="italic">Exp Dermatol, 27</span>. 340-357.
        https://doi.org/10.1111/exd.13514
      </p>
      <p className="citation">
        <sup>12</sup> Phone interview with Anne Marre Bautista, an eczema patient advocate sharing
        her journey via social media/Instagram. August 16, 2021.
      </p>
      <p className="citation">
        <sup>13</sup> Lewis-Jones, S. (2006). Quality of life and childhood atopic dermatitis: the
        misery of living with childhood eczema. <span className="italic">Int J Clin Pract, 60</span>
        (8). 984-992. https://doi.org/10.1111/j.1742-1241.2006.01047.x
      </p>
      <p className="citation">
        <sup>14</sup> Silverberg, J.I., Garg, N.K., Paller, A.S., Fishbein, A.B., Zee, P.C. (2015).
        Sleep disturbances in adults with eczema are associated with impaired overall health: a US
        population-based study. <span className="italic">J Invest Dermatol, 135</span>(1). 55-56.
        https://doi.org/10.1038/jid.2014.325
      </p>
      <p className="citation">
        <sup>15</sup> Zuberbier, T., Orlow, S.J., Paller, A.S., et al. (2006). Patient perspectives
        on the management of atopic dermatitis.{' '}
        <span className="italic">J Allergy Clin Immunol, 118</span>(1). 226-232.
        https://doi.org/10.1016/j.jaci.2006.02.031
      </p>
      <p className="citation">
        <sup>16</sup> Lifschitz, C. (2015). The impact of atopic dermatitis on quality of life.{' '}
        <span className="italic">Ann Nutr Metab, 66</span> (suppl 1). 24-40.
        https://doi.org/10.1159/000370226
      </p>
      <p className="citation">
        <sup>17</sup> Anderson, R.T., Rajagopalan, R. (2001). Effects of allergic dermatosis on
        health-related quality of life. <span className="italic">Curr Allergy Asthma Rep, 1</span>{' '}
        (4). 309-315. https://doi.org/10.1007/s11882-001-0041-3
      </p>
      <p className="citation">
        <sup>18</sup> Granstein, R.D., Cornelius, L., Shinkai, K. (2017). Diversity in dermatology—a
        call for action. <span className="italic">JAMA Dermatol, 153</span>(6). 499-500.
        https://doi.org/10.1001/jamadermatol.2017.0296
      </p>
      <p className="citation">
        <sup>19</sup> Giesey RL, Mehrmal S, Uppal P, et al. The global burden of skin and
        subcutaneous disease: a longitudinal analysis from the Global Burden of Disease Study from
        1990-2017. <span className="italic">Skin</span>. 2021;5(2):125-136.
      </p>
      <p className="citation">
        <sup>20</sup> Flohr C, Hay R. Putting the burden of skin diseases on the global map.{' '}
        <span className="italic">Br J Dermatol</span>. 2021;184:189-190.
      </p>
      <p className="citation">
        <sup>21</sup> Kaundinya T, Kundu RV. Improving cultural competency and practicing cultural
        humility in dermatologic training: skin of color education and board certification.{' '}
        <span className="italic">J Am Acad Dermatol.</span> 2021 Mar 23:S0190-9622(21)00614-9.
      </p>
    </section>
  );
}

export default Citation;
